/* eslint-disable class-methods-use-this */
import { DEFAULT_USERINFOS } from 'utils/__consts/Administration/User'
import { SERVICE_AUTRE_VALUE } from 'utils/__consts/Common/Service'
import {
  ContactPreference,
  UserEntity,
} from 'utils/__interfaces/Administrations/Users/UserEntity'
import {
  SingleUserWDH,
  UserWDH,
} from 'utils/__interfaces/Administrations/Users/UserWDH'

class UsersNormalizer {
  normalize(usersList: UserWDH[]): UserEntity[] {
    return usersList.map((item) => {
      let pref: ContactPreference = DEFAULT_USERINFOS.preferences

      if (item?.preferences) {
        pref = JSON.parse(item?.preferences)
      }

      return {
        id: item['@id'].replace('/users/', ''),
        type: item.type,
        firstname: item.firstname,
        lastname: item.lastname,
        username: item.username,
        contratId: item.contratId,
        createdAt: item.createdAt ? new Date(item.createdAt) : undefined,
        state: item.state,
        lastConnexionDate: item.lastConnexionDate
          ? new Date(item.lastConnexionDate)
          : undefined,
        // for user details:
        email: item.email,
        roles: item.roles,
        service: item.service ?? SERVICE_AUTRE_VALUE,
        UPN: item.UPN,
        passwordExpirationDate: item.passwordExpirationDate
          ? new Date(item.passwordExpirationDate)
          : undefined,
        officePhone: item.officePhone,
        mobilePhone: item.mobilePhone,
        preferences: pref,
        organizations: item.organizations,
        couldBeImpersonated: item.couldBeImpersonated,
        accessDocs: Boolean(item.accessDocs),
        accessDemands: Boolean(item.accessDemands),
        isSuperAdminTech: Boolean(item.isSuperAdminTech),
      }
    })
  }

  normalizeSingle(usersList: SingleUserWDH[]): UserEntity[] {
    return usersList.map((item) => {
      let pref: ContactPreference = DEFAULT_USERINFOS.preferences

      if (item?.preferences) {
        pref = JSON.parse(item?.preferences)
      }
      const roles = item.roles?.map((role) => {
        return role.name
      })
      return {
        id: item['@id'].replace('/users/', ''),
        type: item.type,
        firstname: item.firstname,
        lastname: item.lastname,
        username: item.username,
        contratId: item.contratId,
        createdAt: item.createdAt ? new Date(item.createdAt) : undefined,
        state: item.state,
        lastConnexionDate: item.lastConnexionDate
          ? new Date(item.lastConnexionDate)
          : undefined,
        // for user details:
        email: item.email,
        roles,
        service: item.service ?? SERVICE_AUTRE_VALUE,
        UPN: item.UPN,
        passwordExpirationDate: item.passwordExpirationDate
          ? new Date(item.passwordExpirationDate)
          : undefined,
        officePhone: item.officePhone,
        mobilePhone: item.mobilePhone,
        preferences: pref,
        organizations: item.organizations,
        couldBeImpersonated: item.couldBeImpersonated,
        updatedBy: item.updatedBy
          ? {
              firstname: item.updatedBy.firstname,
              lastname: item.updatedBy.lastname,
              email: item.updatedBy.email,
            }
          : undefined,
        accessDemands: Boolean(item.accessDemands),
        accessDocs: Boolean(item.accessDocs),
        isSuperAdminTech: Boolean(item.isSuperAdminTech),
      }
    })
  }
}

export default new UsersNormalizer()
